const getTime = () => {
  const date = new Date()
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()
  return `${hours}${minutes < 10 ? ':0' : ':'}${minutes}${seconds < 10 ? ':0' : ':'}${seconds}`
}

const introduction = [
  `Welcome to Qian's Terminal!`,
  {
    type: 'system',
    label: 'System',
    content: `cd YaoSiQian`
  },
  {
    type: 'system',
    label: 'System',
    content: 'Now introducing myself...'
  },
  {
    time: getTime(),
    type: 'info',
    label: 'Name:',
    content: 'Siqian Yao'
  },
  {
    time: getTime(),
    type: 'info',
    label: 'Sex:',
    content: 'Male'
  },
  {
    time: getTime(),
    type: 'info',
    label: 'Age:',
    content: '13'
  },
  {
    time: getTime(),
    type: 'info',
    label: 'Email:',
    content: 'admin@yaosiqian.cn'
  },
  {
    time: getTime(),
    type: 'info',
    label: 'Aim:',
    content: 'Three goals as follows:'
  },
  {
    type: 'black',
    label: '=> 1.',
    content: 'Be happy eneryday.'
  },
  {
    type: 'black',
    label: '=> 2.',
    content: 'Study in a great high school and university in China.'
  },
  {
    type: 'black',
    label: '=> 3.',
    content: 'Become an akesome geeker.'
  }
]

export default {
  intro: {
    description: 'Introducting myself again.',
    run(print) {
      let i = 0
      return new Promise(resolve => {
        const interval = setInterval(() => {
          print(introduction[i])
          i++
          if (!introduction[i]) {
            clearInterval(interval)
            resolve({ type: 'success', label: 'Done', content: 'My introduction is over!' })
          }
        }, 500)
      })
    }
  },
  echo: {
    description: 'Echoes input.',
    run(print, input) {
      return new Promise(resolve => {
        print({
          time: getTime(),
          label: 'Echo',
          type: 'success',
          content: input
        })
        resolve({ type: 'success', label: '', content: '' })
      })
    }
  },
  open: {
    description: 'Open a specified url in a new tab.',
    run(print, input) {
      return new Promise((resolve) => {
        if (!input) {
          resolve({ type: 'error', label: 'Error', content: 'a url is required!' })
          return
        }
        if (!input.startsWith('http')) {
          resolve({ type: 'error', label: 'Error', content: 'Please add `http` or `https` prefix!' })
          return
        }
        print({ type: 'success', label: 'Success', content: 'Opening' })

        window.open(input, '_blank')
        resolve({ type: 'success', label: 'Done', content: 'Page Opened!' })
      })
    }
  },
  blog: {
    description: 'Open my blog in a new tab.',
    run(print) {
      return new Promise((resolve) => {
        print({ type: 'error', label: 'Error', content: 'No blogs found.' })

        // window.open('https://tomotoes.com/blog', '_blank')
        // resolve({ type: 'success', label: 'Done', content: ':)' })
      })
    }
  },
  bilibili: {
    description: 'Open my Bilibili channel in a new tab.',
    run(print) {
      return new Promise((resolve) => {
        print({ type: 'success', label: 'Success', content: 'Opening' })

        window.open('https://space.bilibili.com/32539465', '_blank')
        resolve({ type: 'success', label: 'Done', content: 'Enjoy videos!' })
      })
    }
  }
}
